import React, {useEffect, useMemo, useRef, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {Colors} from "../../../assets/colors/Colors";
import SelectForm from "../../../components/ComponentesFormularios/SelectForm";
import Tooltip from "@mui/material/Tooltip";
import {modalCRUDService} from "../../../services/modalCRUDService";
import {FormProvider, useForm, useFormContext, useWatch} from "react-hook-form";
import {
  classResponsiveFormDoubleWidthHeader, classResponsiveFormDoubleWidthHeaderWithoutPaddingX,
  ERROREMAILFIELDREQUIRED,
  ERRORFIELDREQUIRED, optionsTiposDocumento
} from "../../../data/ConstantForm";
import { classResponsiveForm, classResponsiveFormWidthHeader,
classResponsiveFormDoubleWidth } from "../../../data/ConstantForm";
import ContainerSectionModal from "../../../components/ContainerSectionModal";
import NestedInputForm from "../../../components/ComponentesFormularios/NestedInputForm";
import {
  convertToString, formatDay,
  getDigitoVerificacion,
  validarEspaciosEnBlanco, validArray,
  validateDiasEntregaVisita, validObjectKeys
} from "../../../util/functions";
import InputForm from "../../../components/ComponentesFormularios/InputForm";
import SelectFormVirtualize from "../../../components/ComponentesFormularios/SelectFormVirtualize";
import NestedSelectVirtualizeForm from "../../../components/ComponentesFormularios/NestedSelectVirtualizeForm";
import GeneradorDirecciones from "../../../components/ComponentesFormularios/GeneradorDireccionesForm";
import {GlobalConstants} from "../../../data/GlobalConstants";
import {isEmpty, isObject} from "../../../util/is";
import {clientesService} from "../../../services/apiClientes";
import Emitter from "../../../EventEmitter/EventEmitter";
import {ConstantEventEmitter} from "../../../data/ConstantEventEmitter";
import OrdenDiasVisita from "../../../components/OrdenDiasVisita";
import Tabs from "../../../components/Tabs";
import {useDropzone} from "react-dropzone";
import Zoom from "react-medium-image-zoom";
import userGenericAvatar from "../../../assets/images/emptyuserphoto.png";
import {CalendarForm} from "../../../components/ComponentesFormularios/CalendarForm";
import { alertQuestionService } from "src/services/alertQuestionService";
import AgGridTable from "src/components/AgGridTable";
import { ConstantsFormCrud } from "src/data/RoutesFormCrud";
import '../../../../src/components/styles.css';

const columnDef = [
  {headerName: 'Zona', field: "CodVendedor", resizable: true, sortable: false, filter: false, width: 100},
  {headerName: 'Negocio', field: "nmPropietario", resizable: true, sortable: false, filter: false, width: 100},
  {headerName: 'Nombre Vendedor', field: "NomVendedor", resizable: true, sortable: false, filter: false, width: 100},
  {headerName: 'ID Agente Comercial', field: "CodAgenteComercial", resizable: true, sortable: false, filter: false, width: 100},
  {headerName: 'Agente Comercial', field: "NomAgenteComercial", resizable: true, sortable: false, filter: false, width: 100},
  {headerName: 'Portafolio', field: "Fuerza", resizable: true, sortable: false, filter: false, width: 100},
]

const baseStyle = {
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '20px',
  borderBottom: "2px dashed #2196f3",
  backgroundColor: '#fafafa',
  color: '#bdbdbd',
  outline: 'none',
  transition: 'border .24s ease-in-out'
};

const activeStyle = {
  borderColor: '#2196f3'
};

const acceptStyle = {
  borderColor: '#00e676'
};

const rejectStyle = {
  borderColor: '#ff1744'
};


function convertArrDaysToStringDays(arr, order = false) {

  let stringData = "";

  for(let i = 0; i < arr.length; i++){
    if(convertToString(arr[i]) !== convertToString(-1)){
      if(order){
        stringData += `${arr[i]};`;
      }
      else{
        stringData += `${formatDay(i)};`;
      }
    }
  }

  return stringData.substring(0, stringData.length - 1);

}

const TypeDocument = ({isEditing, isAddMode, stateSelects, validacion}) => {

  const {setValue, control, formState: { errors } } = useFormContext();

  const tipeDocumento = useWatch({
    control,
    name: "tipoDocumento"
  })

  const ref = useRef(tipeDocumento);

  useEffect(() => {
    if(convertToString(tipeDocumento) !== convertToString(ref.current)){
      setValue("documento", "");
    }
  }, [tipeDocumento])

  return (
    <>

      <SelectForm inputProps={{control}} disabled={!isEditing} identificador="tipoDocumento" label="Tipo Documento"
                  options={stateSelects?.arrTipoDocumentos}  required={true} className={`w-auto px-2`}
                  customError={errors.tipoDocumento ? ERRORFIELDREQUIRED : null}
                  style={validacion != undefined && validacion.tipoDocumento ? {color: 'red'} : ''} />

      <InputForm inputProps={{control}} disabled={!isEditing} identificador="documento" label="Nro. Documento"
                 placeholder="Ej: 1098000000" type={convertToString(tipeDocumento) !== "C.E." ? "number" : "text"} required={true} className={`${classResponsiveForm}`}
                 customError={errors.documento ? "Longitud min 3 y max 13" : null} rules={{ minLength: 3, maxLength: 13}}
                 style={validacion != undefined && validacion.documento ? {color: 'red'} : ''} />

    </>
  )

}

const RazonSocialByNaturalezaJuridica = ({isEditing, validacion}) => {

  const dispatch = useDispatch();
  const {setValue, control, formState: { errors } } = useFormContext();

  const values = useWatch({
    control,
    name: ["naturalezaJuridica", "nombre1", "nombre2", "apellido1", "apellido2"]
  })

  const tipologia = useWatch({
    control,
    name: "idTipologia"
  })

  useEffect(() => {

    if(values[0] === "N"){
      setValue("razonSocial", validarEspaciosEnBlanco(
        `${values[1] ? values[1] : ""} ${values[2] ? values[2] : ""} ${values[3] ? values[3] : ""} ${values[4] ? values[4] : ""}`
      ))
    }
    else if(values[0] === "J"){
      setValue("nombre1", "")
      setValue("nombre2", "")
      setValue("apellido1", "")
      setValue("apellido2", "")
    }

  }, [values[0]])

  useEffect(() => {

    if(values[0] === "N"){
      setValue("razonSocial", validarEspaciosEnBlanco(
        `${values[1] ? values[1] : ""} ${values[2] ? values[2] : ""} ${values[3] ? values[3] : ""} ${values[4] ? values[4] : ""}`
      ))
    }

  }, [values[1], values[2], values[3], values[4]])

  useEffect( async() => {
    if(tipologia != null){
      try {
        const res = await clientesService.getSubCanalByTipologia(tipologia?.id)

        const { data, status} = res

        if(status) {
          setValue('canal', data.canal)
          setValue('subCanal', data.subcanal)
        }

      } catch (error) {
        dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError, message: error.toString()}})
      }
    }
  }, [tipologia])


  return(
    <>
    <div>
      <InputForm inputProps={{control}} readOnly={values[0] !== "N"} disabled={!isEditing}  identificador="nombre1"
                  label="Primer Nombre" placeholder="Ej: Carlos" type="text" className={/* classResponsiveForm */ `w-auto px-2`}
                  required={values[0] === "N"} customError={errors.nombre1 ? "Longitud max 30" : null} rules={{ maxLength: 30}}
                  style={validacion != undefined && validacion.nombre1 ? {color: 'red'} : ''}/>

        <InputForm inputProps={{control}} readOnly={values[0] !== "N"} disabled={!isEditing} identificador="nombre2"
                  label="Segundo Nombre" placeholder="Ej: Andres" type="text" className={/* classResponsiveForm */ `w-auto px-2`}
                  required={false} customError={errors.nombre2 ? "Longitud max 30" : null} rules={{ maxLength: 30}}
                  style={validacion != undefined && validacion.nombre2 ? {color: 'red'} : ''}/>


        <InputForm inputProps={{control}} readOnly={values[0] !== "N"} disabled={!isEditing} identificador="apellido1"
                  label="Primer Apellido" placeholder="Ej: Peréz" type="text" className={/* classResponsiveForm */ `w-auto px-2`}
                  required={values[0] === "N"} customError={errors.apellido1 ? "Longitud max 30" : null} rules={{ maxLength: 30}}
                  style={validacion != undefined && validacion.apellido1 ? {color: 'red'} : ''}/>

        <InputForm inputProps={{control}} readOnly={values[0] !== "N"} disabled={!isEditing} identificador="apellido2"
                  label="Segundo Apellido" placeholder="Ej: Gaviria" type="text" className={/* classResponsiveForm */ `w-auto px-2`}
                  required={false} customError={errors.apellido2 ? "Longitud max 30" : null} rules={{ maxLength: 30}}
                  style={validacion != undefined && validacion.apellido2 ? {color: 'red'} : ''}/>
    </div>
    <InputForm inputProps={{control}} readOnly={values[0] === "N"} disabled={!isEditing} identificador="razonSocial"
                 label="Razón Social" placeholder="Ej: Tienda Peréz" type="text" className={`w-50 px-2`}
                 required={true} customError={errors.razonSocial ? ERRORFIELDREQUIRED : null}
                 style={validacion != undefined && validacion.razonSocial ? {color: 'red'} : ''} />

    </>
  )

}

const InformacionBasicaComponent = ({isEditing, isAddMode, validacion}) => {

  const generalServicesState = useSelector( state => state.generalServices );
  const [phoneError, setPhoneError] = useState({estadoCelular: true, estadoTelefono: true, msg: '*Ingresar teléfono o celular'})
  const { control, formState: { errors } } = useFormContext();

  const telefono = useWatch({
    control,
    name: 'telFijo'
  })

  const cel = useWatch({
    control,
    name: 'celular'
  })

  useEffect(() => {
    if(telefono != '') setPhoneError({...phoneError, estadoCelular: false, estadoTelefono: true})

    if(cel != '') setPhoneError({...phoneError, estadoTelefono: false, estadoCelular: true})

    if(telefono == '' && cel == '') {
      setPhoneError({...phoneError, estadoTelefono: true, estadoCelular: true})
    }

  }, [telefono, cel])

  return(
    <div className="row mx-0 px-0">
      <div style={{width: '100%'}}>
        <InputForm inputProps={{control}} disabled={true} identificador="idERP" label="ID ERP"
                  type="text" required={false} className={`${classResponsiveForm}`}/>

        <TypeDocument isEditing={isEditing} isAddMode={isAddMode} stateSelects={generalServicesState} style={classResponsiveFormWidthHeader} validacion={validacion}/>

        <NestedInputForm disabled={!isEditing} keyFatherValue="documento" keyIdentificador="digitoVerificacion"
                        label="Dig. Verificación" placeHolder="Ej: 6" type="number" readOnly={true} className={classResponsiveForm}
                        required={true} customError={errors.digitoVerificacion ? ERRORFIELDREQUIRED : null} executeFunction={getDigitoVerificacion}/>

        <SelectForm inputProps={{control}} disabled={!isEditing} identificador="naturalezaJuridica" label="Naturaleza Juridica"
                    options={generalServicesState?.arrNaturalezasJuridicas} required={true} className={`${classResponsiveFormWidthHeader}`}
                    customError={errors.naturalezaJuridica ? ERRORFIELDREQUIRED : null}
                    style={validacion != undefined && validacion.naturalezaJuridica ? {color: 'red'} : ''}/>
      </div>

      <div>
          <RazonSocialByNaturalezaJuridica isEditing={isEditing} validacion={validacion}/>
          <InputForm inputProps={{control}} disabled={!isEditing} identificador="telFijo" label="Teléfono"
                  placeholder="Ej: 6787621" type="number" required={phoneError.estadoTelefono} className={`${classResponsiveForm}`}
                  customError={errors.telFijo && errors.celular ? phoneError['msg'] : errors.telFijo ? "Longitud min 7 y max 11" : null} rules={{ minLength: 7, maxLength: 11}}
                  style={validacion != undefined && validacion.telFijo ? {color: 'red'} : ''}/>

          <InputForm inputProps={{control}} disabled={!isEditing} identificador="celular" label="Celular"
                  placeholder="Ej: 3002467589" type="number" required={phoneError.estadoCelular} className={`${classResponsiveFormWidthHeader}`}
                  customError={errors.celular && errors.telFijo ? phoneError['msg'] : errors.celular ? "Longitud min 10 y max 11" : null} rules={{ minLength: 10, maxLength: 11}}
                  style={validacion != undefined && validacion.celular ? {color: 'red'} : ''}/>
      </div>

      <div className="w-100">
        <InputForm inputProps={{control}} disabled={true} identificador="idCcup" label="ID CCUP"
                  type="text" required={false} className={`${classResponsiveForm}`}/>

        <SelectFormVirtualize inputProps={{control}} disabled={true} identificador="nbPuntoVentaGrupo5" label="Grupo 5"
                                  options={generalServicesState?.arrGrupoPV} className={`${classResponsiveForm}`}/>
      </div>

      <InputForm inputProps={{control}} disabled={!isEditing} identificador="correo" label="Correo Electrónico"
                 placeholder="Ej: amovil@amovil.co" type="text" required={false} className={`${classResponsiveFormDoubleWidth}`}
                 rules={{pattern: { value: /\S+@\S+\.\S+/}}} customError={errors.correo ? ERROREMAILFIELDREQUIRED : null}
                 style={validacion != undefined && validacion.correo ? {color: 'red'} : ''}/>

      <InputForm inputProps={{control}} disabled={!isEditing} identificador="correoAux" label="Correo Electrónico Aux."
                 placeholder="Ej: amovil@amovil.co" type="text" required={false} className={`${classResponsiveFormDoubleWidth}`}
                 rules={{pattern: { value: /\S+@\S+\.\S+/}}} customError={errors.correoAux ? ERROREMAILFIELDREQUIRED : null} />

      <InputForm inputProps={{control}} disabled={!isEditing} identificador="correoRecepcionDE" label="Correo de facturación electrónica"
                 placeholder="Ej: amovil@amovil.co" type="text" required={false} className={`${classResponsiveFormDoubleWidth}`}
                 rules={{pattern: { value: /\S+@\S+\.\S+/}}} customError={errors.correoRecepcionDE ? ERROREMAILFIELDREQUIRED : null} />

    </div>
  )

}

const InformacionUbicacionComponent = ({isEditing, validacion}) => {

  const generalServicesState = useSelector( state => state.generalServices );
  const { control, formState: { errors } } = useFormContext();

  return(
    <div className="row mx-0 px-0">

      <div style={{width: '100%'}}>
        <InputForm inputProps={{control}} readOnly={!isEditing} disabled={!isEditing} identificador="nombreNegocio"
                        label="Nombre negocio" placeholder="Ej: Peréz Tienda" type="text" className={`${classResponsiveFormDoubleWidthHeaderWithoutPaddingX} px-2`}
                        required={true} customError={errors.nombreNegocio ? ERRORFIELDREQUIRED : null}
                        style={validacion != undefined && validacion.nombreNegocio ? {color: 'red'} : ''}/>

        <InputForm inputProps={{control}} disabled={!isEditing} identificador="barrio" label="Barrio"
                   placeholder="Ej: Versalles" type="text" required={true} className={`${classResponsiveFormDoubleWidthHeader}`}
                   customError={errors.barrio ? "Longitud max 50" : null} rules={{ maxLength: 50}}
                   style={validacion != undefined && validacion.barrio ? {color: 'red'} : ''}/>
      </div>


      <GeneradorDirecciones props={{control}} className={`${classResponsiveFormDoubleWidthHeaderWithoutPaddingX}`} identificador="direccion" required={true}
                            label="Dirección" disabled={!isEditing} customError={errors.direccion ? ERRORFIELDREQUIRED : null}  />


      <InputForm inputProps={{control}} disabled={!isEditing} identificador="dane" label="Dane"
                    type="text" required={false} className={`${classResponsiveForm}`} customError={null} />

      <InputForm inputProps={{control}} disabled={!isEditing} identificador="estrato" label="Estrato"
                   type="text" required={true} className={`${classResponsiveForm}`} customError={null}
                   style={validacion != undefined && validacion.estrato ? {color: 'red'} : ''}/>

      <div style={{width: '100%'}}>

        <SelectFormVirtualize inputProps={{control}} disabled={!isEditing} identificador="idPais" label="País" required={true}
                              className={classResponsiveFormWidthHeader} options={generalServicesState?.arrPaises}
                              customError={errors.idPais ? ERRORFIELDREQUIRED : null}/>

        <NestedSelectVirtualizeForm disabled={!isEditing} keyIdentificador="idDepartamento" label="Departamento" required={true}
                                    className={classResponsiveFormWidthHeader} options={generalServicesState?.arrDepartamentos}
                                    customError={errors.idDepartamento ? ERRORFIELDREQUIRED : null}
                                    keyFatherValue="idPais"/>

        <NestedSelectVirtualizeForm disabled={!isEditing} keyIdentificador="idCiudad" label="Ciudad" required={true}
                                    className={classResponsiveFormWidthHeader} options={generalServicesState?.arrCiudades}
                                    customError={errors.idCiudad ? ERRORFIELDREQUIRED : null}
                                    keyFatherValue="idDepartamento"/>

        <InputForm inputProps={{control}} disabled={!isEditing} identificador="zonaPostal" label="Zona postal"
                  placeholder="Ej: 57" type="text" required={true} className={`${classResponsiveFormWidthHeader}`}
                  customError={errors.zonaPostal ? ERRORFIELDREQUIRED : null} rules={{ maxLength: 50}}
                  style={validacion != undefined && validacion.zonaPostal ? {color: 'red'} : ''}/>
      </div>
    </div>
  )

}

const InformacionTipologiaComponent = ({isEditing, validacion}) => {

  const generalServicesState = useSelector( state => state.generalServices );
  const { control, formState: { errors } } = useFormContext();

  return(
    <div className="row mx-0 px-0">

      <div style={{width: '100%'}}>
        <SelectFormVirtualize inputProps={{control}} disabled={true} identificador="agenteComercial" label="Agente Comercial"
                              options={generalServicesState?.arrEmpresas}  required={true} className={`${classResponsiveFormDoubleWidth}`}
                              customError={errors.agenteComercial ? ERRORFIELDREQUIRED : null} />

        <SelectFormVirtualize inputProps={{control}} disabled={!isEditing} identificador="clasificacion" label="Clasificacion Punto"
                    options={generalServicesState?.arrClasificacionesPunto}  required={true} className={`${classResponsiveFormDoubleWidth}`}
                    customError={errors.clasificacion ? ERRORFIELDREQUIRED : null} />

        <SelectForm inputProps={{control}} disabled={!isEditing} identificador="segmentoNecesidad" label="Necesidad"
                    options={generalServicesState?.arrSegmentosNecesidad}  required={true} className={`${classResponsiveFormDoubleWidth}`}
                    customError={errors.segmentoNecesidad ? ERRORFIELDREQUIRED : null}
                    style={validacion != undefined && validacion.segmentoNecesidad ? {color: 'red'} : ''} />

      </div>
      <div style={{width: '100%'}}>
        <SelectFormVirtualize inputProps={{control}} disabled={!isEditing} identificador="idTipologia" label="Tipología"
                              options={generalServicesState?.arrTipologias}  required={true} className={classResponsiveFormDoubleWidth}
                              customError={errors.idTipologia ? ERRORFIELDREQUIRED : null} />

        <SelectFormVirtualize inputProps={{control}} disabled={true} identificador="canal" label="Canal"
                              options={generalServicesState?.arrCanales}  required={true} className={`${classResponsiveFormDoubleWidth}`}
                              customError={errors.canal ? ERRORFIELDREQUIRED : null}/>

        <SelectFormVirtualize inputProps={{control}} disabled={true} identificador="subCanal" label="Sub Canal" required={true}
                                    className={classResponsiveFormDoubleWidth} options={generalServicesState?.arrSubCanales}
                                    customError={errors.subCanal ? ERRORFIELDREQUIRED : null}/>
      </div>

    </div>
  )

}

const ParametrosFacturacionComponent = ({isEditing}) => {

  const generalServicesState = useSelector( state => state.generalServices );
  const { control, formState: { errors } } = useFormContext();

  return(
    <div className="row mx-0 px-0">


      <SelectFormVirtualize inputProps={{control}} disabled={!isEditing} identificador="respFiscal" label="Responsabilidad Fiscal"
                  options={generalServicesState?.arrRespFiscales}  required={true} className={`${classResponsiveFormDoubleWidth}`}
                  customError={errors.respFiscal ? ERRORFIELDREQUIRED : null} />

      <SelectFormVirtualize inputProps={{control}} disabled={!isEditing} identificador="regFiscal" label="Regimen Fiscal"
                            options={generalServicesState?.arrRegFiscales}  required={true} className={classResponsiveFormDoubleWidth}
                            customError={errors.regFiscal ? ERRORFIELDREQUIRED : null} />

      <SelectFormVirtualize inputProps={{control}} disabled={!isEditing} identificador="respIva" label="Responsabilidad IVA"
                            options={generalServicesState?.arrRespIVA}  required={true} className={`${classResponsiveFormDoubleWidth}`}
                            customError={errors.respIva ? ERRORFIELDREQUIRED : null}/>

    </div>
  )

}

const InformacionDiasVisitasEntregaComponent = ({isEditing, idZona, infoSolicitud}) => {
  const generalServicesState = useSelector( state => state.generalServices );
  const dispatch = useDispatch()
  const { control, formState: { errors } } = useFormContext();
  const estado = infoSolicitud.estado
  const tipoSolicitud = infoSolicitud.tipoSolicitud

  const changeCheck = () => {
    if(!generalServicesState['checked']){
      alertQuestionService.showAlert({
        title: 'Aplicar cambios días de visita y entrega', question: '¿Deseas aplicar los cambios en los días de visita?',
        message: 'Recuerda que al aceptar se cambiará los días de visita y entrega por la ruta propuesta.',
        actionBtnAceptar:() => {
          dispatch({
            type: 'setStateGeneralServices', generalServices: {
              ...generalServicesState,
              checked: !generalServicesState['checked']
            }
          })
          alertQuestionService.clear()
        },
        actionBtnCancelar: () => alertQuestionService.clear(),
        type: GlobalConstants.alertInfo
        })

    }else{
      dispatch({
        type: 'setStateGeneralServices', generalServices: {
          ...generalServicesState,
          checked: !generalServicesState['checked']
        }
      })
    }
  }


  return(
    <React.Fragment>
      <div className="my-2">
        <InputForm inputProps={{control}} disabled={true} identificador="zona" label="Zona"
                  type="text" required={false} className={`${classResponsiveForm}`}
                  customError={null}/>

        <InputForm inputProps={{control}} disabled={true} identificador="vendedor" label="Vendedor"
                  type="text" required={false} className={`${classResponsiveFormDoubleWidth}`}
                    customError={null}/>

        <SelectFormVirtualize inputProps={{control}} disabled={estado != 100 && tipoSolicitud != 57 ? true : false} identificador="portafolio" label="Portafolio"
                              options={generalServicesState?.arrPortafolios}  required={true} className={`${classResponsiveFormWidthHeader}`}
                              customError={errors.portafolio ? ERRORFIELDREQUIRED : null}/>

        <SelectFormVirtualize inputProps={{control}} disabled={!isEditing} identificador="frecuencia" label="Frecuencia"
                              options={generalServicesState?.arrFrecuencias}  required={true} className={`${classResponsiveForm}`}
                              customError={errors.frecuencia ? ERRORFIELDREQUIRED : null}/>
      </div>

      {
        generalServicesState['estadoDiasVisitaAnterior'] &&
        <div className="form-check w-25" style={{marginLeft: '0.9rem'}}>
            <input  onChange={changeCheck} className="form-check-input" style={{width: '1.3rem', height: '1.3rem'}} type="checkbox" disabled={generalServicesState['estado'] != 100 && generalServicesState['estado'] != 101 ? true : false} checked={generalServicesState['checked']} id="aceptarCambioVisita" name="aceptarCambioVisita"/>
            <label className="form-check-label no-space-break" style={{marginLeft: '1rem', fontSize: '1rem', marginTop: '0.2rem', userSelect: 'none'}} htmlFor="aceptarCambioVisita">
              Aplicar cambios días de visita
            </label>
        </div>
      }

      <div>
        <div className="py-2 d-flex align-items-center justify-content-center">
            <div className="mr-2 d-flex align-items-center">
                <div className="circulo-indicador-visita"/>
                <div className="ml-1" style={{fontSize: "1rem"}}>Días y orden de visita</div>
            </div>
            <div className="ml-2 d-flex align-items-center">
                <div className="circulo-indicador-entrega"/>
                <div className="ml-1" style={{fontSize: "1rem"}}>Días y orden de entrega</div>
            </div>
        </div>

        {
          generalServicesState['estadoDiasVisitaAnterior'] &&
          <div className="d-flex flex-column align-items-center mt-3">
            <div className="d-flex flex-column p-2 align-items-center w-75" style={{ border: '1px solid #C6C6C640', borderRadius: 5, backgroundColor: '#C6C6C640' }}>
              <p style={{fontWeight: 'bold', fontSize: '1rem', margin: 0}}>Días de visita y entrega actuales</p>
              <OrdenDiasVisitaBeforeForm idZona={idZona} isEditing={isEditing}/>
            </div>
          </div>
        }
        <div className="d-flex flex-column align-items-center mt-3">
          {
            generalServicesState['estadoDiasVisitaAnterior'] &&
            <p style={{fontWeight: 'bold', fontSize: '1rem', margin: 0}}>Días de visita y entrega propuestos</p>
          }
          <OrdenDiasVisitaForm idZona={idZona} isEditing={isEditing}/>
        </div>
      </div>

    </React.Fragment>
  )
}

const InformacionActualCliente = ({infoSolicitud}) => {

  const tableRef = useRef()
  const [dataRow, setDataRow] = useState(infoSolicitud?.rutaActual)

  useEffect(() => {
    setDataRow(infoSolicitud?.rutaActual)
  }, [infoSolicitud?.rutaActual])

  return (
    <div>
      <AgGridTable
        referencia={tableRef}
        dataList={dataRow || []}
        columnDef={columnDef}
        rowSelection={'single'}
        height='40vh'
      />
    </div>
  )
}

const OrdenDiasVisitaForm = ({idZona, isEditing}) => {

  const { setValue, formState: { errors }, control } = useFormContext();

  const values = useWatch({
    control,
    name: ["diasVisita", "diasEntrega", "ordenVisita", "ordenEntrega"]
  })

  const handleChangeDiasEntregaVisita = (tipo, dia, orden) => {

    let diasVisitaClone = values[0].slice();
    let ordenVisitaClone = values[2].slice();
    let diasEntregaClone = values[1].slice();
    let ordenEntregaClone = values[3].slice();


    if(GlobalConstants.typeVisita === tipo){

      diasVisitaClone[dia] = 1;
      ordenVisitaClone[dia] = orden;
      if(isEmpty(orden)){
        diasVisitaClone[dia] = -1;
        ordenVisitaClone[dia] = -1;
      }
    }
    else if(GlobalConstants.typeEntrega === tipo){
      diasEntregaClone[dia] = 1;
      ordenEntregaClone[dia] = orden;
      if(isEmpty(orden)){
        diasEntregaClone[dia] = -1;
        ordenEntregaClone[dia] = -1;
      }
    }

    setValue("diasVisita", diasVisitaClone);
    setValue("ordenVisita", ordenVisitaClone);
    setValue("diasEntrega", diasEntregaClone);
    setValue("ordenEntrega", ordenEntregaClone);

    Emitter.emit(ConstantEventEmitter.eventCloseModalDiasEntregaVisita);

  }

  return(

    <>

      {
        !isEmpty(idZona) ?

          <OrdenDiasVisita diasVisita={values[0]} diasEntrega={values[1]} ordenVisita={values[2]} ordenEntrega={values[3]} idZona={isObject(idZona) ? idZona?.id : idZona}
                           onChange={(tipo, dia, orden) => handleChangeDiasEntregaVisita(tipo, dia, orden)} required={true} hideTitle={true}
                           customError={errors.diasVisita ||  errors.diasEntrega ? ERRORFIELDREQUIRED : null} showDivider={false} tab="SOLICITUDES_CLIENTES" disabled={!isEditing}/>
          :
          <div className="w-100 p-3 d-flex justify-content-center align-items-center" style={{border: "1px dashed #9c9fa6", borderRadius: 10, backgroundColor: Colors.WHITE}}>

            <p className="p-3 w-50 text-center font-weight-bold" style={{fontSize: 18, color: Colors.RED_SWITCH_INACTIVE}}> Para configurar los días de visita y entrega, debe seleccionar una zona (vendedor) </p>

          </div>
      }

    </>

  )
}

const OrdenDiasVisitaBeforeForm = ({idZona}) => {

  const { setValue, control } = useFormContext();

  const values = useWatch({
    control,
    name: ["diasVisitaBef", "diasEntregaBef", "ordenVisitaBef", "ordenEntregaBef"]
  })

  const handleChangeDiasEntregaVisita = (tipo, dia, orden) => {

    let diasVisitaClone = values[0].slice();
    let ordenVisitaClone = values[2].slice();
    let diasEntregaClone = values[1].slice();
    let ordenEntregaClone = values[3].slice();


    if(GlobalConstants.typeVisita === tipo){

      diasVisitaClone[dia] = 1;
      ordenVisitaClone[dia] = orden;
      if(isEmpty(orden)){
        diasVisitaClone[dia] = -1;
        ordenVisitaClone[dia] = -1;
      }
    }
    else if(GlobalConstants.typeEntrega === tipo){
      diasEntregaClone[dia] = 1;
      ordenEntregaClone[dia] = orden;
      if(isEmpty(orden)){
        diasEntregaClone[dia] = -1;
        ordenEntregaClone[dia] = -1;
      }
    }

    setValue("diasVisitaBef", diasVisitaClone);
    setValue("ordenVisitaBef", ordenVisitaClone);
    setValue("diasEntregaBef", diasEntregaClone);
    setValue("ordenEntregaBef", ordenEntregaClone);

    Emitter.emit(ConstantEventEmitter.eventCloseModalDiasEntregaVisita);

  }

  return(

    <>
      <OrdenDiasVisita diasVisita={values[0]} diasEntrega={values[1]} ordenVisita={values[2]} ordenEntrega={values[3]} idZona={isObject(idZona) ? idZona?.id : idZona}
                        onChange={(tipo, dia, orden) => handleChangeDiasEntregaVisita(tipo, dia, orden)} required={false} hideTitle={true}
                        customError={null} showDivider={false} tab="SOLICITUDES_CLIENTES" disabled={true}/>
    </>

  )
}

const DatosBasicos = ({isEditing, idZona, params, id, isMDS, infoSolicitud, isDeny}) => {
  const generalServicesState = useSelector( state => state.generalServices );

  const authState = useSelector( state => state.auth )
  const { idUsuario } = authState;
  const { handleSubmit, control, formState: { errors } } = useFormContext();
  const dispatch = useDispatch();
  const [validacion, setValidacion] = useState(infoSolicitud.validacion)
  //* state para ocultar o visualizar los botones de aceptar - denegar
  const [state, setState] = useState({accept: true, cancel: true})

  //useEFFECT
  useEffect(() => {
    setValidacion(infoSolicitud.validacion)
  }, [infoSolicitud.validacion])

  useEffect(() => {
    if(isMDS || !isEditing){
      setState({...state, cancel: false})
    }

    if(infoSolicitud.bloqueoSolicitud || !isEditing){
      setState({...state, accept: false})
    }
  }, [])

  const handleStateClient = (id) => {
    modalCRUDService.showModal({
      props: {id},
      type: ConstantsFormCrud.modalFormDenegado,
      title: `Motivo denegación`,
      isAddMode: false,
      isEditable: false,
      dense: true,
      size: `sm`
    });

  }

  const saveData = (data, tipo, estado) => {

    let errorSave = false;

    alertQuestionService.showAlert({
      title: 'Actualizar Información', question: '¿Deseas actualizar la información de la solicitud?',
      message: 'Recuerda que al actualizar la información el estado de la solicitud cambiará a "Aprobado Liberación"',
      actionBtnAceptar: async() => {
        alertQuestionService.clear();
        modalCRUDService.clear();

        if(generalServicesState['estadoDiasVisitaAnterior'] && !generalServicesState['checked']){
          data.diasVisita = convertArrDaysToStringDays(data.diasVisitaBef);
          data.ordenVisita = convertArrDaysToStringDays(data.ordenVisitaBef, true);
          data.diasEntrega = convertArrDaysToStringDays(data.diasEntregaBef);
          data.ordenEntrega = convertArrDaysToStringDays(data.ordenEntregaBef, true);
        }else{
          data.diasVisita = convertArrDaysToStringDays(data.diasVisita);
          data.ordenVisita = convertArrDaysToStringDays(data.ordenVisita, true);
          data.diasEntrega = convertArrDaysToStringDays(data.diasEntrega);
          data.ordenEntrega = convertArrDaysToStringDays(data.ordenEntrega, true);
        }

        const response = await clientesService.updateInfoSolicitudClienteById({data, id})

        if(response['status']){
          if(estado != 103){
            const response = await clientesService.setEstadoClientesManual([id], isMDS ? 105 : 103, idUsuario)

            if(response['status']){

              if((tipo == 50 || tipo == 51) && data['idERP'] < 88000000 ){

                const response = await clientesService.getConsecutivo({identificador: id, usuario: idUsuario, idERP: data.idERP})
                if(response['status']){

                  dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertSuccess , message: response['msg'] } });

                }else { errorSave = true; console.log('2') }
              }else {
                dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertSuccess , message: response['msg'] } });
              }

              if(params){
                dispatch({
                  type: 'setStateGeneralServices', generalServices: {
                    ...generalServicesState,
                    stateFlag: !generalServicesState?.stateFlag
                  }
                })
              }

            } else { errorSave = true;  console.log('3') }
          }else {
            dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertSuccess , message: "Se actualizaron los datos exitosamente" } });
          }
        }else { errorSave = true; console.log('4'); }

        //! Si ocurre error en alguna petición se visualiza el mensaje.
        if(errorSave){
          dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError , message: `Ha ocurrido un error, comunicate con soporte` } });
        }
        alertQuestionService.clear();
      },
      actionBtnCancelar: () => alertQuestionService.clear(),
      type: GlobalConstants.alertInfo
    })
  }

  const onSuccessSubmit = (data) => {
    saveData(data, params.data.idTpSolicitud, params.data.idEstado)
  }

  const onErrorSubmit = errors => {
    dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError , message: 'Faltan campos obligatorios, por favor válida la información' } });
  }

  return(
    <React.Fragment>

      <div className="d-flex align-items-center justify-content-between">

        <div className="row px-1" style={{width: '90%'}} >

          <CalendarForm inputProps={{control}} disabled={true} identificador="fechaIngreso"  label="Fecha Ingreso"
                      required={true} className={`px-2 w-200`}
                      customError={errors.fechaIngreso ? ERRORFIELDREQUIRED : null}/>

          <SelectFormVirtualize inputProps={{control}} disabled={true} identificador="estado" label="Estado" required={true}
                                className={`px-2 col-xs-12 col-sm-9 col-md-7 col-lg-5 col-xl-5`} options={generalServicesState?.arrEstados?.filter(x => convertToString(x?.tipo) === 'Solicitudes-Clientes')}
                                customError={errors.estado ? ERRORFIELDREQUIRED : null}/>

          <SelectFormVirtualize inputProps={{control}} disabled={true} identificador="tipoSolicitud" label="Tipo de Solicitud" required={true}
                                className={`px-2 col-xs-10 col-sm-9 col-md-7 col-lg-4 col-xl-4`} options={generalServicesState?.arrTiposSolicitudes}
                                customError={errors.estado ? ERRORFIELDREQUIRED : null}/>

        </div>

        <div className="d-flex justify-content-end align-items-center px-0 pb-3" style={{width: '10%'}}>
          { isEditing && <div className="d-flex justify-content-between align-items-center">
            {
              state.accept && (
                <Tooltip title="Guardar y Aprobar" aria-label="guardar">
                  <a onClick={handleSubmit(onSuccessSubmit, onErrorSubmit)}
                    className="icon-container-actions d-flex">
                    <div style={{backgroundColor: Colors.COLOR_GREEN_DARK}}/>
                    <i style={{color: Colors.COLOR_GREEN_DARK}} className="fas fa-check fa-2x"/>
                  </a>
                </Tooltip>
              )
            }
            {
              state.cancel && (
                <Tooltip title="Denegar" aria-label="denegar">
                  <a onClick={ () => handleStateClient(id)}
                    className="icon-container-actions d-flex">
                    <div style={{backgroundColor: Colors.RED_SWITCH_INACTIVE}}/>
                    <i style={{color: Colors.RED_SWITCH_INACTIVE}} className="fas fa-ban fa-2x"/>
                  </a>
                </Tooltip>
              )
            }
            </div>
          }
        </div>
      </div>

      <div className={`${isDeny == true ? '' : 'saDisable'}`} style={{width: '100%'}}>
        <div className="row px-1" style={{width: '100%'}}>
          <InputForm inputProps={{control}} disabled={true} identificador="observacion" label="Motivo Denegación"
                    type="text" required={false} className={`px-2 col-xs-12 col-sm-12 col-md-10 col-lg-10 col-xl-6`}/>
        </div>
      </div>

      <ContainerSectionModal label="Información Básica" component={<InformacionBasicaComponent isEditing={isEditing} validacion={validacion}/>}/>

      <ContainerSectionModal label="Datos de punto de venta" component={<InformacionUbicacionComponent isEditing={isEditing} validacion={validacion}/>}/>

      <ContainerSectionModal label="Datos de segmentación" component={<InformacionTipologiaComponent isEditing={isEditing} validacion={validacion}/>}/>

      <ContainerSectionModal label="Parámetros de facturación" component={<ParametrosFacturacionComponent isEditing={isEditing}/>}/>

      <ContainerSectionModal label="Información de Ruta de la Solicitud" component={<InformacionDiasVisitasEntregaComponent isEditing={isEditing} idZona={idZona} infoSolicitud={infoSolicitud}/>}/>

      <ContainerSectionModal label="Información Rutas Actuales del Cliente" component={<InformacionActualCliente infoSolicitud={infoSolicitud}/>}/>

    </React.Fragment>
  )
}

const HeaderClientInformation = ({infoCli, id}) => {

  return(
    <div className="d-flex align-items-center">

      <div className="ml-2">
        <img className="ml-2" style={{width: 100, height: 100, borderRadius: 100 / 2, border: `1px solid ${Colors.GRAY_LOW}` }} src={userGenericAvatar} alt="..."/>
      </div>

      <div className="px-3 py-2">
        <p className="p-0 m-0 font-weight-bold" style={{fontSize: "1.2em"}}>{isEmpty(infoCli?.razonSocial) ? "XXXX XXXX XXXX XXXX" : convertToString(infoCli.razonSocial).toUpperCase()}</p>
        <p className="p-0 m-0" style={{fontSize: "1em"}}>{`Doc. ${isEmpty(infoCli?.documento) ? "XXX-XXX-XXX" : infoCli.documento}`}</p>
        <p className="p-0 m-0" style={{fontSize: "1em"}}>{`Cod. Interno. ${isEmpty(id) ? "XXX-XXX-XXX" : id}`}</p>
      </div>

    </div>
  )

}

const Evidencias = ({isEditing, infoCliTemp, id, setCantidadFotos}) => {

  const [ infoCli, setInfoCli ] = useState(infoCliTemp);

  const dispatch = useDispatch();
  const { register: registerEvidencias, setValue: setValueEvidencias, handleSubmit: handleSubmitEvidencias,
    reset: resetEvidencias, control: controlEvidencias, formState: { errors: errorsEvidencias } } = useForm({defaultValues: {}});

  const [stateAcceptedFiles,  setStateAcceptedFiles] = useState([]);

  const [stateImagenes, setStateImagenes] = useState({stateImages: [], stateImagesDelete: []});

  const { stateImages, stateImagesDelete } = stateImagenes;

  const {
    acceptedFiles,
    fileRejections,
    getRootProps,
    getInputProps,
    isDragActive,
    isDragAccept,
    isDragReject,
    inputRef
  } = useDropzone({
    accept: 'image/jpeg, image/png',
    maxFiles: 6
  });

  const style = useMemo(() => ({
    ...baseStyle,
    ...(isDragActive ? activeStyle : {}),
    ...(isDragAccept ? acceptStyle : {}),
    ...(isDragReject ? rejectStyle : {})
  }), [
    isDragActive,
    isDragReject,
    isDragAccept
  ]);

  const removeCurrentFile = item  => {
    setStateImagenes({ stateImages :stateImages?.filter(x => convertToString(x.idTipo) !== convertToString(item.idTipo)), stateImagesDelete: [...stateImagesDelete, item] });
  }

  const removeFile = file  => {
    acceptedFiles.splice(file, 1);
    setStateAcceptedFiles(acceptedFilesItem);
  }

  const acceptedFilesItem = () => {
    return acceptedFiles.map((file, index) => {
      return <li key={file.path}>
        <div className="d-flex flex-column align-items-center justify-content-center px-2">
          <div className="position-relative">
            <Zoom>
              <img className="borderImg" src={URL.createObjectURL(file)}
                   style={{width: 100, height: 100, borderRadius: 10, objectFit: 'cover'}}/>
            </Zoom>
            <div className="d-flex justify-content-end align-items-center px-0 pb-3 position-absolute" style={{top:-10, right: -10}}>
              <Tooltip title="Eliminar archivo" aria-label="eliminarArchivo">
                <a onClick={() => removeFile(index)}
                   className="icon-container-actions d-flex mr-0">
                  <div style={{backgroundColor: Colors.RED_SWITCH_INACTIVE}}/>
                  <i style={{color: Colors.RED_SWITCH_INACTIVE}} className="fas fa-times"/>
                </a>
              </Tooltip>
            </div>

          </div>

          <SelectFormVirtualize inputProps={{control: controlEvidencias}} disabled={!isEditing}
                                identificador={`file${index}`} label="Tipo Doc."
                                options={optionsTiposDocumento} required={true} className={`w150 mb-2 mt-3`}
                                customError={errorsEvidencias[file.path] ? ERRORFIELDREQUIRED : null} showId={false}/>
        </div>
      </li>
    })
  }

  useEffect(() => {
    setStateAcceptedFiles(acceptedFilesItem);
  }, [acceptedFiles])

  const removeAll = () => {
    acceptedFiles.length = 0
    acceptedFiles.splice(0, acceptedFiles.length)
    inputRef.current.value = ''
    setStateAcceptedFiles(null);
  }

  const busqueda = (arr) => {
    return arr.reduce((acc, obj) => {
      acc[obj.id] = ++acc[obj.id] || 0;
      return acc;
    }, {})
  };

  const duplicados = (arr) => {
    return arr.filter((obj) => {
      return !isEmpty(obj.id) && busqueda(arr)[obj.id];
    })
  };


  const fileRejectionItems = fileRejections.map(({ file, errors }) => (
    <li key={file.path}>
      {file.path} - {file.size} bytes
      {
        errors?.length > 0 &&
        <li className="font-weight-bold" style={{color: Colors.RED_SWITCH_INACTIVE}} key={errors[0]?.code}>El tipo de archivo debe ser una imagen de tipo image/jpeg o image/png y no debe exceder 6 imagenes</li>
      }

    </li>
  ));

  const onSuccessSubmitEvidencias = data => {


    let currentImages = validArray(stateImages).slice();
    let arrAcceptedFiles = validArray(acceptedFiles).slice();

    if(arrAcceptedFiles.length === 0 && currentImages.length === 0){
      dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError , message: "Debe seleccionar o arrastrar almenos una imagen para subir" } });
      return;
    }


    let arrImgSeleccionadas = Object.values(data);

    let existenDuplicados = validArray(duplicados(arrImgSeleccionadas)).slice();

    if(existenDuplicados.length > 0){
      let duplicadosList = existenDuplicados.map(x => x.text);
      dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError , message: `Los documentos no se pueden subir dos veces, acontinuacion estos son los duplicados ${JSON.stringify(duplicadosList)}` } });
      return;
    }

    let imgExistentes = [];
    let imgAgregar = [];
    let i = 0;
    for(let item of arrAcceptedFiles){

      let tipoImgAceptada = data[`file${i}`];
      let existeEnLasImagenesActuales = currentImages.find(x => convertToString(x?.idTipo) === convertToString(tipoImgAceptada?.id));

      console.log(currentImages)
      console.log(existeEnLasImagenesActuales)

      if(existeEnLasImagenesActuales){
        imgExistentes.push(existeEnLasImagenesActuales.nmTipo);
      }
      else{

        imgAgregar.push({
          url: arrAcceptedFiles[i],
          idTipo: tipoImgAceptada?.id,
          nmTipo: tipoImgAceptada?.text
        })
      }

      i++;
    }


    if(imgExistentes.length > 0){
      dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError , message: `Ya existen los siguientes documentos ${JSON.stringify(imgExistentes)}` } });
      return;
    }


    clientesService.crudEvidenciasSolicitudesCliente([...stateImages, ...imgAgregar], {id}).then(
      response => {
        const {status, msg, data} = response;

        if (status) {

          removeAll();

          resetEvidencias({
            file1: "",
            file2: "",
            file3: "",
            file4: "",
            file5: "",
            file6: ""
          })

          setStateImagenes({stateImages: [...stateImages, ...imgAgregar] , stateImagesDelete: []})

          dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertSuccess , message: msg } });

        } else {
          dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError , message: msg } });
        }


      },
      error => {
        dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError , message: error.toString() } });
      }
    )


  }

  const onErrorSubmitEvidencias = error => { }

  useEffect(() => {

    let jsTercero = [];

    try{
      jsTercero = JSON.parse(infoCli?.jsTercero);
    }
    catch (e) { jsTercero = []; }

    let jsTerceroTemp = Object.assign({}, validObjectKeys(jsTercero));

    let jsArrDocumentos = validArray(jsTerceroTemp?.arrDocTerceros).slice();

    let arrImagenes = [];

    for(let item of jsArrDocumentos){

      let objValues = Object.values(item);
      arrImagenes = [...arrImagenes, ...objValues];

    }

    setStateImagenes({stateImages: validArray(arrImagenes).slice(), stateImagesDelete: []})

    if(jsTercero?.length != undefined){ setCantidadFotos(jsTercero?.length)
    }else{
      setCantidadFotos(Object.keys(jsTercero.arrDocTerceros[0]).length)
    }

  }, [])

  return(

    <div>

      <div className="d-flex justify-content-between align-items-end px-0 mb-3">

        <HeaderClientInformation infoCli={infoCli} id={id}/>

        <div className="py-1 d-flex flex-column justify-content-between">
          <div>
            {
              Object.keys(infoCli)?.length > 0 && isEditing ?
                <button onClick={handleSubmitEvidencias(onSuccessSubmitEvidencias, onErrorSubmitEvidencias)} className="btn btn-primary text-center px-2 py-1" style={{height: 35, backgroundColor: Colors.GREEN_SWITCH_ACTIVE, borderColor: Colors.GREEN_SWITCH_ACTIVE}}><i className="fas fa-check mx-2"/> {` Guardar Evidencias`}</button>
                :
                <button className="btn btn-primary text-center px-2 py-1" style={{height: 35, backgroundColor: Colors.DARK_GRAY, borderColor: Colors.DARK_GRAY}}><i className="fas fa-check Mx-2"/> {` Guardar Evidencias`}</button>
            }
          </div>
        </div>
      </div>

      <div className="my-1 borderUploadDocument">

        <div className="py-2 px-4 d-flex justify-content-center align-items-center mt-2 borderBottomDashed">

          {
            stateImages?.length === 0 ?
              <h4 className="m-0 vertical-align-center">No tienes evidencias guardadas</h4>
              :
              <div className='w-100'>
                <h4 className="font-weight-bold fontSizeDropCurrentFiles">Archivos actuales</h4>
                <ul id="currentFiles">
                  {
                    stateImages?.map((item) => (
                      <li key={item.idTipo}>
                        <div className="d-flex flex-column align-items-center justify-content-center px-2">
                          <div className="position-relative">
                            <Zoom>
                              <img className="borderImg" src={
                                typeof item?.url === "string" ? item?.url?.includes('http')? item?.url : `${GlobalConstants.urlUploadImage}${item?.url}` : URL.createObjectURL(item?.url)
                              } style={{width: 100, height: 100, borderRadius: 10, objectFit: 'cover'}}/>
                            </Zoom>
                            <div className={`d-flex justify-content-end align-items-center px-0 pb-3 position-absolute ${!isEditing ? 'saDisable' : ''}`} style={{top:-10, right: -10}}>
                              <Tooltip title="Eliminar archivo" aria-label="eliminarArchivo">
                                <a onClick={() => removeCurrentFile(item)}
                                   className="icon-container-actions d-flex mr-0">
                                  <div style={{backgroundColor: Colors.RED_SWITCH_INACTIVE}}/>
                                  <i style={{color: Colors.RED_SWITCH_INACTIVE}} className="fas fa-times"/>
                                </a>
                              </Tooltip>
                            </div>
                          </div>
                          <p className="mb-0 mt-2 font-weight-bold">{item.nmTipo}</p>
                        </div>
                      </li>
                    ))
                  }
                </ul>
              </div>
          }

        </div>

        <section>
          <div className={`text-center minHeight200 d-flex flex-column justify-content-center cursor-pointer ${!isEditing ? 'saDisable' : '' }`} {...getRootProps({style})}>
            <input {...getInputProps()} />
            <p className="font-weight-bold mb-1" style={{color: Colors.DARK_GRAY}}>Arrastra hasta aqui las imagenes que desees o haz click aqui para seleccionarlas</p>
            <em className="font-weight-bold" style={{color: Colors.DARK_GRAY}}>(Solo *.jpeg and *.png imagenes son aceptadas)</em>
          </div>
          <aside className="px-3">
            {
              acceptedFiles?.length > 0 &&
              <>
                <h4 className="mt-3 font-weight-bold fontSizeDropFilesAccepted">Archivos aceptados</h4>
                <ul id="acceptedFiles">{stateAcceptedFiles}</ul>
              </>
            }
            {
              fileRejections?.length > 0 &&
              <>
                <h4 className="my-2 font-weight-bold fontSizeDropFilesRejected">Archivos rechazados</h4>
                <ul id="rejectedFiles">{fileRejectionItems}</ul>
              </>
            }
          </aside>
        </section>

      </div>

    </div>

  )

}

const FormSolicitudesTercerosClientesPtoVentaCRUD = ({ isAddMode, isEditing, properties }) => {
    const generalServicesState = useSelector( state => state.generalServices );
    const { infoSolicitud, params, id, idZona, isMDS, isDeny = false } = properties;
    const dispatch = useDispatch();
    const methods = useForm({
      defaultValues: {
        ...infoSolicitud,
        diasVisita: isEmpty(infoSolicitud?.diasVisita) ? [-1,-1,-1,-1,-1,-1,-1] : infoSolicitud.diasVisita,
        ordenVisita: isEmpty(infoSolicitud?.ordenVisita) ? [-1,-1,-1,-1,-1,-1,-1]: infoSolicitud.ordenVisita,
        diasEntrega: isEmpty(infoSolicitud?.diasEntrega) ? [-1,-1,-1,-1,-1,-1,-1]: infoSolicitud.diasEntrega,
        ordenEntrega: isEmpty(infoSolicitud?.ordenEntrega) ? [-1,-1,-1,-1,-1,-1,-1]: infoSolicitud.ordenEntrega,
        estrato: infoSolicitud['estrato'] == 0 ? 3 : infoSolicitud['estrato'],
        celular: infoSolicitud.celular == 0 ? '' : infoSolicitud.celular,

        diasVisitaBef: isEmpty(infoSolicitud?.diasVisitaBef) ? [-1,-1,-1,-1,-1,-1,-1] : infoSolicitud.diasVisitaBef,
        ordenVisitaBef: isEmpty(infoSolicitud?.ordenVisitaBef) ? [-1,-1,-1,-1,-1,-1,-1]: infoSolicitud.ordenVisitaBef,
        diasEntregaBef: isEmpty(infoSolicitud?.diasEntregaBef) ? [-1,-1,-1,-1,-1,-1,-1]: infoSolicitud.diasEntregaBef,
        ordenEntregaBef: isEmpty(infoSolicitud?.ordenEntregaBef) ? [-1,-1,-1,-1,-1,-1,-1]: infoSolicitud.ordenEntregaBef,
        zonaEspejo: []
      }
    });
    const {register} = methods;
    const [cantidadFotos, setCantidadFotos] = useState(0)
    const [msgState, setMessageState] = useState({state: false, msg: ''})
    const [expanded, setExpanded] = useState(true)
    const tableRef = useRef();

    useEffect(() => {
      register("diasVisita", { validate: value => !isEmpty(validateDiasEntregaVisita(value)) || 'Este Campo es requerido'})
      register("ordenVisita", { validate: value => !isEmpty(value) || 'Este Campo es requerido'})
      register("diasEntrega", { validate: value => !isEmpty(validateDiasEntregaVisita(value)) || 'Este Campo es requerido'})
      register("ordenEntrega", { validate: value => !isEmpty(value) || 'Este Campo es requerido'})

      dispatch({
        type: 'setStateGeneralServices', generalServices: {
          ...generalServicesState,
          estadoDiasVisitaAnterior: infoSolicitud.changeDiasOrdenVisita ? true : false,
          checked: false,
          checkedZonaEspejo: false,
          estado: infoSolicitud['estado'],
          tipoSolicitud: infoSolicitud['tipoSolicitud'],
          zonaEspejo: []
        }
      })

      if(infoSolicitud.bloqueoSolicitud){
        setMessageState({state: true, msg: infoSolicitud.msgBloqueo})
      }
    },[])

    const textWithLB = () => {
      let txt = msgState.msg;

      let arrTxt = txt.split('\n').map((linea, index) => (
        <React.Fragment key={index}>
          {linea}
          <br/>
        </React.Fragment>
      ))

      return arrTxt
    }

    return(
        <FormProvider {...methods} className="container mx-0 px-0 w-100 mw-100">

          {msgState.state &&
            <div>
              <div className="d-flex justify-content-center align-items-center">
                <h5 style={{color: '#E53935', fontWeight: 400}} className='mb-0 mx-1 font-weight-bold text-center'>{textWithLB()}</h5>
                <Tooltip title="Mostrar/Ocultar" aria-label="hideandshow">
                  <a onClick={() => {setExpanded(!expanded)}}
                    data-target={`#collapseContainerMsg`} aria-expanded={expanded} aria-controls={`#collapseContainerMsg`} className="icon-container-actions d-flex mr-0">
                    <div style={{backgroundColor: Colors.WHITE, boxShadow: "none"}}/>
                    <i style={{color: '#E53935'}} className={expanded ? "fas fa-angle-up fa-2x" : "fas fa-angle-down fa-2x"}/>
                  </a>
                </Tooltip>
              </div>
              <div className={expanded ? "collapse show" : "collapse"} id={`collapseContainerMsg`}>
                <div className="mx-5">
                  <AgGridTable
                    referencia={tableRef}
                    dataList={infoSolicitud.dataTercero || []}
                    columnDef={columnDef}
                    rowSelection={'single'}
                    height='35vh'
                  />
                </div>
              </div>
            </div>
          }

          <Tabs tabs={[
            {show: true, text: "Datos Básicos", value: "datosBasicos", icon: "fas fa-briefcase",
              component: <DatosBasicos isEditing={isEditing} idZona={idZona} params={params} id={id} isMDS={isMDS} infoSolicitud={infoSolicitud} isDeny={isDeny}/>},
            {show: true, text: `Evidencias (${cantidadFotos})`, value: "evidencias", icon: "fas fa-camera-retro",
              component: <Evidencias isEditing={isEditing} infoCliTemp={infoSolicitud} id={id} setCantidadFotos={setCantidadFotos} />}
          ]} defaultValue="datosBasicos" />

        </FormProvider>
    )

}

export default FormSolicitudesTercerosClientesPtoVentaCRUD;
